import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { combineReducers, configureStore } from '@reduxjs/toolkit';

import authReducer from './authSlice';
import chatReducer from './chatSlice';
import classesReducer from './classesSlice';
import featureReducer from './featuresSlice';
import peiReducer from './peiSlice';
import profileReducer from './profileSlice';
import studentReducer from './studentSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  features: featureReducer,
  pei: peiReducer,
  chat: chatReducer,
  classes: classesReducer,
  student: studentReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['profile', 'student'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
